import { Box, Flex, Icon, Text, Typography } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import styles from './StatusCheckVariant.module.scss'

export function StatusCheckVariant() {
  const { t } = useTranslation()

  return (
    <Flex direction="column" gap={24}>
      <Flex direction="column" gap={8}>
        <Typography variant="h2">{t('typography.oneStepSignUp.Goodstack.statusCheckVariant.title')}</Typography>
        <Text size="small" color="var(--colors-gray-400)">
          {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.subtitle')}
        </Text>
      </Flex>
      <Flex direction="column" gap={12}>
        <Flex className={styles.card} align="center" gap={16}>
          <Box className={styles.iconCircle}>
            <Icon name="gift" size={6} color="inherit" />
          </Box>
          <Flex direction="column">
            <Text size="small" fontWeight="bold">
              {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.card1Title')}
            </Text>
            <Text size="small" color="var(--colors-gray-400)" className={styles.cardDescription}>
              {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.card1Description')}
            </Text>
          </Flex>
        </Flex>
        <Flex className={styles.card} align="center" gap={16}>
          <Box className={styles.iconCircle}>
            <Icon name="piggy-bank" size={6} color="inherit" />
          </Box>
          <Flex direction="column">
            <Text size="small" fontWeight="bold">
              {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.card2Title')}
            </Text>
            <Text size="small" color="var(--colors-gray-400)" className={styles.cardDescription}>
              {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.card2Description')}
            </Text>
          </Flex>
        </Flex>
        <Flex className={styles.card} align="center" gap={16}>
          <Box className={styles.iconCircle}>
            <Icon name="diamond" size={6} color="inherit" />
          </Box>
          <Flex direction="column">
            <Text size="small" fontWeight="bold">
              {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.card3Title')}
            </Text>
            <Text size="small" color="var(--colors-gray-400)" className={styles.cardDescription}>
              {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.card3Description')}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex align="center" gap={8}>
        <Icon name="info" size={6} color="primary400" className={styles.infoIcon} />
        <Text size="small" color="var(--colors-gray-400)">
          {t('typography.oneStepSignUp.Goodstack.statusCheckVariant.reassurance')}
        </Text>
      </Flex>
    </Flex>
  )
}
